import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-4-small', 'Number4Small', [["path",{"d":"M10 8v3a1 1 0 0 0 1 1h3"}],["path",{"d":"M14 8v8"}]]);